import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton, Table } from "react-bootstrap";
import SidebarLayout from "../components/shared/SidebarLayout";
import { apiGet } from "../Utils/apiFetch";
import apiPath from "../Utils/apiPath";
import { compact, isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import AuthContext from "../context/AuthContext";
import obj from "../Utils/helpers";
import { useTranslation } from "react-i18next";
import { RxCross2 } from "react-icons/rx";
import LayoutNew from "../components/shared/LayoutNew";


const Earn = () => {
    const navigate = useNavigate();
const {t} = useTranslation()
const [showTab, setShowTab] = useState("myinfo");
  return (
    <LayoutNew>
    <div class="page-text">
         <div class="back-header menu-header promotion-header">
        <div class="left-arrow"><span>
        </span></div><p>Earning</p>
        <button
             className="bg-transparent border-0 p-0 close-b"
             onClick={() => navigate(-1)}
           >
             <RxCross2 />
           </button>
      </div>
        <div class="tabs-link">
            <a href="javascript:void(0)"onClick={()=>setShowTab("myinfo")}  class="active">Referral Info </a>
            <a href="javascript:void(0)" onClick={()=>setShowTab("myreferral")}>My Referral </a>
        </div>
{showTab=="myinfo" ?
    <div  id="#tab1">
            <img src="../assets/images/referral-program-banner.png"
                alt="" />

            <div class="ebox">
                <h3>How does our <br/> Referral Program work?</h3>
                <p>You can earn cash rewards up to three referral tiers when you refer your friends. <br/> Invite your
                    friends to join together and be entitled for lifetime cash rewards each time your friends place a
                    bet.
                </p>
                <button class="rule-btn"> Rules </button>

                <div class="reward-slide">
                    <span class="slide-btn"><img
                            src="../assets/images/icon-arrow-type09.svg"
                            alt=""/></span>
                    <span>
                        <h4> Cash Reward Ratio </h4>
                        <p> Turnover Range:More Than 100</p>
                    </span>
                    <span class="slide-btn right"><img
                            src="../assets/images/icon-arrow-type09.svg"
                            alt=""/></span>
                </div>
                <div>
                    <div class="slide-d">
                        <span>Tier1</span>
                        <span>0.1%</span>
                    </div>
                    <div class="slide-d">
                        <span>Tier2</span>
                        <span>0.05%</span>
                    </div>
                    <div class="slide-d">
                        <span>Tier3</span>
                        <span>0.01%</span>
                    </div>
                </div>
            </div>

            <div class="ebox">
                <h3> How to earn more rewards </h3>
                <div class="number-list">
                    <img class="nl-img"
                        src="../assets/images/referral-program-flowch-1.png"
                        alt="" />
                    <span class="nl-number">1</span>
                    <div class="step-box">
                        <h4> Send an invitation </h4>
                        <p> To start your referral journey </p>
                        <img src="../assets/images/arrow-deco.png"
                            class="st-1-img" alt="" />
                        <img src="../assets/images/arrow-deco.png"
                            class="st-2-img" alt="" />
                    </div>
                </div>
                <div class="number-list n-2">
                    <img class="nl-img"
                        src="../assets/images/referral-program-flowch-2.png"
                        alt="" />
                    <span class="nl-number">2</span>
                    <div class="step-box">
                        <h4> Friend registration </h4>
                        <p> with bets placed </p>
                        <img src="../assets/images/arrow-deco.png"
                            class="st-1-img" alt="" />
                        <img src="../assets/images/arrow-deco.png"
                            class="st-2-img" alt="" />
                    </div>
                </div>
                <div class="number-list">
                    <img class="nl-img"
                        src="../assets/images/referral-program-flowch-3.png"
                        alt="" />
                    <span class="nl-number">3</span>
                    <div class="step-box">
                        <h4> Get rewarded daily <br/> weekly, monthly </h4>
                        <p> and enjoy with your friends </p>
                        <img src="../assets/images/arrow-deco.png"
                            class="st-1-img" alt="" />
                        <img src="../assets/images/arrow-deco.png"
                            class="st-2-img" alt="" />
                    </div>
                </div>
                <button class="rule-btn1"> Refer a friend now </button>
            </div>

            <div class="ebox">
                <h3> Referral leaderboard </h3>
                <div class="fer-div">
                    <div class="number-box"  style={{marginTop: `22.0117px`}}>
                        <div class="nb-data">
                            <div class="place"><img
                                    src="../assets/images/crown.svg"
                                    alt="" />
                                Second place</div>
                            <img src="../assets/images/avatar2.png"
                                class="ref-winner-img" alt="" />
                            <span class="u-id"> mo****59 </span>
                            <span class="u-point"> 44.03 </span>
                        </div>
                        <img src="../assets/images/referral-program-leaderboard-rank2.png"
                            alt="" />
                    </div>
                    <div class="number-box">
                        <div class="nb-data">
                            <div class="place"><img
                                    src="../assets/images/crown.svg"
                                    alt="" />
                                First place</div>
                            <img src="../assets/images/avatar1.png"
                                class="ref-winner-img" alt="" />
                            <span class="u-id"> mo****59 </span>
                            <span class="u-point"> 44.03 </span>
                        </div>
                        <img src="../assets/images/referral-program-leaderboard-rank1.png"
                            alt="" />
                    </div>
                    <div class="number-box"  style={{marginTop: `22.0117px`}}>
                        <div class="nb-data">
                            <div class="place"><img
                                    src="../assets/images/crown.svg"
                                    alt="" />
                                Third place</div>
                            <img src="../assets/images/avatar3.png"
                                class="ref-winner-img" alt="" />
                            <span class="u-id"> mo****59 </span>
                            <span class="u-point"> 44.03 </span>
                        </div>
                        <img src="../assets/images/referral-program-leaderboard-rank3.png"
                            alt="" />
                    </div>
                </div>

                <h3 style={{marginTop: `32.0171px`}}> Who received the bonus? </h3>

                <div class="t-view">
                    <div class="v-row">
                        <span> **kmou** </span>
                        <span>461.00 <em>INR</em></span>
                        <span>2024/08/08 <br/> 05:45:40</span>
                    </div>
                    <div class="v-row">
                        <span> **kmou** </span>
                        <span>461.00 <em>INR</em></span>
                        <span>2024/08/08 <br/> 05:45:40</span>
                    </div>
                    <div class="v-row">
                        <span> **kmou** </span>
                        <span>461.00 <em>INR</em></span>
                        <span>2024/08/08 <br/> 05:45:40</span>
                    </div>
                    <div class="v-row">
                        <span> **kmou** </span>
                        <span>461.00 <em>INR</em></span>
                        <span>2024/08/08 <br/> 05:45:40</span>
                    </div>
                </div>
            </div>
        </div>
        :
        <div  id="#tab2">
            <img src="../assets/images/referral-program-banner.png"
                alt="" />

            <div class="ebox text-center pb-0">
                <p> Your Referral Code </p>
                <h3>YpCXeY</h3>
                <div class="referal-code">
                <img src="data:image/png;base64,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"/>
                </div>
                <div class="rc-btn">
                    <button class="rule-btn1 m-0"> Copy Link </button>
                    <button class="rule-btn1 m-0"> Share </button>
                </div>
            </div>

            <div class="ebox refral-p">
                <h2> 0</h2>
                <p> Active downlines <img
                        src="../assets/images/question.svg" alt=""/></p>

                <div class="refral-p-row">
                    <h4>Lifetime Cash Rewards</h4>
                    <span>0</span>
                </div>
                <div class="refral-p-row">
                    <h4>Referral Turnover</h4>
                    <span>0</span>
                </div>
                <div class="refral-p-row cash-reward">
                    <span>
                        <h4>Cash Rewards</h4>
                        <span>0</span>
                    </span>
                    <button class="rule-btn m-0" > Claim All </button>

                </div>


            </div>

        </div>
}
        

        
    </div>
    </LayoutNew>
  );
};

export default Earn;
